import { Host, h, } from "@stencil/core";
import { formMessageLogic, formTooltipLogic } from "../../common/form";
import { repositionScroll } from "../../common/reposition-scroll";
import { KeyboardKeys as KK } from "../../common/types";
import { exportParts } from "../../common/export-parts";
import state from "../store";
import { mutationObserverRemoved } from "../../common/mo-removed";
export class GxgComboBox {
    constructor() {
        this.popOver = false;
        this.toolTip = false;
        this.fixedIcon = undefined;
        this.disabled = false;
        this.label = undefined;
        this.labelPosition = "above";
        this.minWidth = "0";
        this.maxWidth = "100%";
        this.listMaxHeight = "244px";
        this.placeholder = "Search item";
        this.disableFilter = false;
        this.disableClear = false;
        this.strict = false;
        this.value = undefined;
        this.caseSensitive = false;
        this.listPosition = "below";
        this.text = undefined;
        this.centerLabel = false;
        this.labelWidth = undefined;
        this.required = false;
        this.validationStatus = "indeterminate";
        this.validationMessage = undefined;
        this.cursorEnd = false;
        this.informationMessage = undefined;
        this.inputTextValue = "";
        this.listIsOpen = false;
        this.inputTextIcon = undefined;
        this.noMatch = false;
        this.lastAllowedValue = undefined;
        this.slottedContent = null;
        this.selectionProgramatic = true;
        this.lastSetValueByUser = undefined;
        this.myObserver = null;
        this.selectedItem = undefined;
        this.removedItem = undefined;
    }
    parts = {
        input: "input",
        clearButton: "clear-button",
        toggleButton: "toggle-button",
    };
    exportparts;
    _mo;
    componentDidLoadFlag = false;
    /**
     * This event is triggered when the combo box value changes.
     */
    valueChanged;
    /**
     * This event is triggered when the combo dropdown is opened
     */
    opened;
    /**
     * This event is triggered when the combo dropdown has closed
     */
    closed;
    /**
     * This event is triggered when the combo dropdown has toggled (opened/closed)
     */
    toggled;
    inputText;
    el;
    mainContainer;
    itemsContainer;
    searchItemsContainer;
    userTyped = false;
    formMessageLogic = formMessageLogic;
    detectClickOutsideCombo = this.detectClickOutsideComboFunc.bind(this);
    detectMouseScroll = this.detectMouseScrollFunc.bind(this);
    componentDidUpdate() {
        const itemsContainerIsOverflowing = this.itemsContainerBottomOverflows();
        itemsContainerIsOverflowing
            ? (this.listPosition = "above")
            : (this.listPosition = "below");
    }
    componentWillLoad() {
        this.setup();
        this.attachExportParts();
        this.mutationRemoveObserver();
    }
    attachExportParts = () => {
        const part = this.el.getAttribute("part");
        const exportPartsResult = exportParts(part, this.parts);
        exportPartsResult.length && (this.exportparts = exportPartsResult);
    };
    mutationRemoveObserver = () => {
        this._mo = mutationObserverRemoved(this.el, this);
    };
    componentDidLoad() {
        this.resizeObserver();
        this.componentDidLoadFlag = true;
        this.evaluatePopOver();
    }
    disconnectedCallback() {
        this.cleanup();
    }
    /*********************************
    METHODS
    *********************************/
    async open() {
        this.listIsOpen = true;
    }
    async close() {
        this.listIsOpen = false;
    }
    async getValueByIndex(index) {
        const enabledItems = this.getEnabledItems();
        const foundItem = enabledItems.filter((item) => item.index === index)[0];
        return foundItem?.value;
    }
    async setValueByIndex(index) {
        const enabledItems = this.getEnabledItems();
        const foundItem = enabledItems.filter((item) => item.index === index)[0];
        if (foundItem && foundItem.value) {
            this.value = foundItem.value;
            return true;
        }
        return false;
    }
    async selectInputText() {
        this.inputText.selectInputText();
    }
    /*********************************
    LISTEN
    *********************************/
    itemSelectedHandler(event) {
        this.value = event.detail.value;
        this.inputText.focus();
    }
    itemDidLoadHandler() {
        this.setIndexes();
        //this.setInitialValue();
    }
    keyDownComboItemHandler(event) {
        event.stopPropagation();
        if (event.detail === "ArrowUp") {
            this.inputText.focus();
        }
        else if (event.detail === "Tab" || event.detail === "Escape") {
            this.listIsOpen = false;
            this.inputText.focus();
        }
    }
    /*********************************
    HANDLERS
    *********************************/
    inputHandler = (e) => {
        this.userTyped = true;
        const value = this.sanitizeString(e.detail);
        const filteredItems = this.filterList(value);
        if (!this.strict) {
            this.value = value;
        }
        else if (filteredItems.length === 1) {
            /*on strict mode, only set value if there is an exact match*/
            this.value = filteredItems[0].value;
        }
    };
    keyDownHandler = (e) => {
        if (e.code === KK.ARROW_DOWN || e.code === KK.ARROW_UP) {
            e.preventDefault();
        }
        let newItem;
        if (e.code === KK.ARROW_DOWN) {
            newItem = this.getNewItem("next");
            newItem?.value && (this.value = newItem?.value);
            repositionScroll(this.itemsContainer, this.selectedItem, KK.ARROW_DOWN);
            e.altKey && this.showList();
        }
        else if (e.code === KK.ARROW_UP) {
            newItem = this.getNewItem("prev");
            newItem?.value && (this.value = newItem?.value);
            repositionScroll(this.itemsContainer, this.selectedItem, KK.ARROW_UP);
        }
        else if (e.code === KK.ENTER) {
            this.hideList();
            this.showAllItems();
        }
        else if (e.code === KK.SPACE) {
            this.showList();
        }
        else if (e.code === KK.ESCAPE) {
            this.showAllItems();
            this.hideList();
        }
        else if (e.code === KK.TAB && this.showList) {
            this.hideList();
        }
    };
    handleValueChangeFormText = (e) => {
        this.value = e.detail;
    };
    /********************************
    WATCH
    *********************************/
    onValueChanged(newValue) {
        setTimeout(() => {
            if (this.componentDidLoadFlag) {
                this.valueChanged.emit(newValue);
            }
            this.clearSelectedItem();
            let value;
            let newItem = undefined;
            if (this.userTyped) {
                value = this.getValueByText(newValue);
            }
            else {
                !this.listIsOpen && this.showAllItems();
                value = newValue;
            }
            newItem = this.getItemByValue(value);
            if (newItem) {
                this.setSelectedItem(newItem);
                this.setIcon(newItem.icon);
                newItem?.textContent && (this.text = newItem.textContent);
            }
            else {
                //this.setIcon(undefined);
                if (this.strict) {
                    this.text = undefined;
                    this.value = undefined;
                }
                else {
                    this.text = newValue;
                }
            }
            this.userTyped = false;
        }, 20);
    }
    listIsOpenHandler(open) {
        let isOpen = false;
        if (open) {
            //list is open
            isOpen = true;
            document.addEventListener("click", this.detectClickOutsideCombo, true);
            document.addEventListener("scroll", this.detectMouseScroll, true);
            this.opened.emit();
            //Reposition .items-container, since it has fixed position
            this.repositionItemsContainer();
            if (this.popOver) {
                this.itemsContainer.showPopover();
            }
        }
        else {
            //list is closed
            document.removeEventListener("click", this.detectClickOutsideCombo, true);
            document.removeEventListener("scroll", this.detectMouseScroll, true);
            this.closed.emit();
            if (this.popOver) {
                this.itemsContainer.hidePopover();
            }
        }
        this.toggled.emit(isOpen);
    }
    selectedItemHandler(newItem) {
        newItem && (newItem.selected = true);
    }
    removedItemHandler(removedItem) {
        const value = removedItem.value;
        if (value === this.value) {
            /*The removed item was the one selected on the combo. Re-evaluation of new value is needed*/
            this.setup();
        }
    }
    /*********************************
    PRIVATE METHODS
    *********************************/
    evaluatePopOver = () => {
        if (this.popOver) {
            this.itemsContainer.setAttribute("popover", "");
        }
    };
    filterList = (text) => {
        text = this.sanitizeString(text);
        !this.caseSensitive && (text = text.toLowerCase());
        const enabledItems = this.getEnabledItems();
        const filteredItems = [];
        if (enabledItems.length) {
            enabledItems.forEach((item) => {
                const itemText = !this.caseSensitive
                    ? item.textContent.toLocaleLowerCase()
                    : item.textContent;
                if (!item.disabled && itemText.includes(text)) {
                    filteredItems.push(item);
                    item.hidden = false;
                }
                else {
                    item.hidden = true;
                }
            });
        }
        if (filteredItems.length >= 1) {
            this.showList();
        }
        else {
            this.hideList();
        }
        return filteredItems;
    };
    showAllItems = () => {
        const enabledItems = this.getEnabledItems();
        enabledItems?.forEach((item) => {
            item?.hidden && (item.hidden = false);
        });
    };
    cleanup = () => {
        this.myObserver.unobserve(document.body);
        document.removeEventListener("click", this.detectClickOutsideCombo, true);
        document.removeEventListener("scroll", this.detectMouseScroll, true);
        this._mo.disconnect();
    };
    setup = () => {
        this.setIndexes();
        this.setInitialValue();
    };
    setIndexes = () => {
        const allItems = this.getAllItems();
        allItems.forEach((item, i) => {
            item.index = i;
        });
    };
    getEnabledItems = () => {
        const enabledItems = [];
        const allItems = this.getAllItems();
        allItems.forEach((item) => {
            !item.disabled && enabledItems.push(item);
        });
        return enabledItems;
    };
    getFilteredItems = () => {
        const enabledItems = this.getEnabledItems();
        const filteredItems = [];
        enabledItems.forEach((item) => {
            !item.hidden && filteredItems.push(item);
        });
        return filteredItems;
    };
    getAllItems = () => {
        const allItems = [];
        const allItemsNodeList = this.el.querySelectorAll("gxg-combo-box-item");
        allItemsNodeList.forEach((item) => {
            allItems.push(item);
        });
        return allItems;
    };
    getItemByValue = (value) => {
        let item;
        if (value) {
            const enabledItems = this.getEnabledItems();
            item = enabledItems.find((item) => {
                return !item.disabled && item?.value && item.value === value;
            });
        }
        return item;
    };
    clearSelectedItem = () => {
        const enabledItems = this.getEnabledItems();
        enabledItems?.forEach((item) => {
            item.selected && (item.selected = false);
        });
        this.selectedItem = undefined;
        this.clearIcon();
    };
    getValueByText = (text) => {
        !this.caseSensitive && (text = text.toLowerCase());
        const enabledItems = this.getEnabledItems();
        const item = enabledItems?.find((item) => {
            const itemText = !this.caseSensitive
                ? item.textContent.toLocaleLowerCase()
                : item.textContent;
            return !item.disabled && itemText === text;
        });
        return item?.value;
    };
    getNewItem = (direction) => {
        const filteredItems = this.getFilteredItems();
        const indexInFiltered = filteredItems?.findIndex((item) => {
            return item.selected;
        });
        if (direction === "next") {
            if (indexInFiltered === -1) {
                /*no selectedItem at the time*/
                return filteredItems[0];
            }
            return filteredItems[indexInFiltered + 1];
        }
        else if (direction === "prev") {
            if (indexInFiltered !== -1) {
                return filteredItems[indexInFiltered - 1];
            }
        }
    };
    setSelectedItem = (item) => {
        if (item) {
            this.selectedItem && (this.selectedItem.selected = false);
            item.selected = true;
            this.selectedItem = item;
            return true;
        }
        return false;
    };
    sanitizeString = (value) => {
        if (typeof value === "string") {
            return value.replace(/\s+/g, " ").trim();
        }
        return value;
    };
    setInitialValue = () => {
        const firstItem = this.getEnabledItems()[0];
        if (!this.value || this.removedItem !== undefined) {
            if (firstItem) {
                this.value = firstItem.value;
                this.text = firstItem.innerText;
            }
            else {
                if (this.strict) {
                    this.value = undefined;
                }
            }
        }
        else {
            const item = this.getItemByValue(this.value);
            if (item) {
                this.text = item.innerText;
                this.inputTextIcon = item.icon;
                item.selected = true;
            }
            else {
                if (this.strict) {
                    this.value = undefined;
                }
                else {
                    this.text = this.value.toString();
                }
            }
        }
    };
    toggleListButtonClickHandler = () => {
        if (!this.disabled) {
            this.showAllItems();
            this.toggleList();
            this.focus();
        }
    };
    inputTextClickHandler = () => {
        if (!this.disabled) {
            this.disableFilter && this.toggleList();
        }
    };
    toggleList = () => {
        if (!this.disabled) {
            this.listIsOpen = !this.listIsOpen;
        }
    };
    showList = () => {
        if (!this.disabled) {
            this.listIsOpen = true;
        }
    };
    hideList = () => {
        if (!this.disabled) {
            this.listIsOpen = false;
        }
    };
    clearIcon = () => {
        if (!this.disabled) {
            this.inputTextIcon = null;
        }
    };
    setIcon(icon) {
        if (icon) {
            this.inputTextIcon = icon;
        }
        else {
            this.inputTextIcon = null;
        }
    }
    focus() {
        this.inputText.focus();
    }
    detectClickOutsideComboFunc(event) {
        const comboMainContainer = this.el.shadowRoot.querySelector(".main-container");
        const x = event.x;
        const y = event.y;
        //Contextual menu coordinates
        const comboMainContainerArea = comboMainContainer.getBoundingClientRect();
        if ((x > comboMainContainerArea.left &&
            x < comboMainContainerArea.right &&
            y > comboMainContainerArea.top &&
            y < comboMainContainerArea.bottom) ||
            (event.screenX === 0 &&
                event.screenY === 0 &&
                event.clientX === 0 &&
                event.clientY === 0)) {
            //Click happened inside the combo
        }
        else {
            this.listIsOpen = false;
            //Click happened outside the combo
        }
    }
    detectMouseScrollFunc() {
        this.listIsOpen = false;
    }
    clearCombo() {
        if (!this.disabled) {
            this.value = undefined;
            this.listIsOpen = true;
            this.focus();
        }
    }
    resizeObserver() {
        this.myObserver = new ResizeObserver((entries) => {
            entries.forEach(() => {
                this.repositionItemsContainer();
            });
        });
        this.myObserver.observe(document.body);
        this.myObserver.observe(this.el);
    }
    repositionItemsContainer() {
        //redefine .main-container width
        const inputText = this.inputText;
        const inputTextWidth = inputText.clientWidth;
        this.itemsContainer.style.width = inputTextWidth + "px";
        //redefine .items-container "top" value
        const inputTextBoundingClient = inputText.getBoundingClientRect();
        const inputTextY = inputTextBoundingClient.y;
        const inputTextHeight = inputTextBoundingClient.height;
        this.itemsContainer.style.top = inputTextY + inputTextHeight + "px";
        if (this.popOver) {
            //redefine .items-container "left" value
            const inputTextX = inputTextBoundingClient.x;
            this.itemsContainer.style.left = inputTextX + "px";
        }
    }
    itemsContainerBottomOverflows() {
        const viewportHeight = window.innerHeight;
        const comboBottom = this.el.getBoundingClientRect().bottom;
        const itemsContainerHeight = this.itemsContainer.clientHeight;
        const result = comboBottom + itemsContainerHeight;
        const itOverflows = true ? result > viewportHeight : false;
        return itOverflows;
    }
    render() {
        const clearIcon = this.value && !this.disableFilter && !this.disableClear;
        return (h(Host, { class: {
                "list-is-opem": this.listIsOpen,
                "gxg-combo-box--disabled": this.disableFilter,
                tooltip: this.toolTip,
                large: state.large,
            }, style: { maxWidth: this.maxWidth, minWidth: this.minWidth }, exportParts: this.exportparts ? this.exportparts : null }, h("div", { class: {
                "main-container": true,
            }, ref: (el) => (this.mainContainer = el) }, this.label ? (h("gxg-label", { labelPosition: this.labelPosition, center: this.centerLabel, width: this.labelWidth }, this.label)) : null, h("div", { class: "outer-wrapper" }, h("div", { class: "search-and-items-container", ref: (el) => (this.searchItemsContainer = el) }, h("div", { class: { "search-container": true } }, h("gxg-form-text", { placeholder: this.placeholder, onInput: this.inputHandler.bind(this), onKeyDown: this.keyDownHandler, onClick: this.inputTextClickHandler, value: this.text, icon: this.fixedIcon || this.inputTextIcon, iconPosition: "start", readonly: this.disableFilter, ref: (el) => (this.inputText = el), validationStatus: this.validationStatus, disabled: this.disabled, onValueChanged: this.handleValueChangeFormText, cursorEnd: this.cursorEnd, preventValueChangedEmit: true, class: { "clear-icon": clearIcon }, part: this.parts.input }), h("div", { class: "buttons-wrapper" }, clearIcon ? (h("gxg-button", { class: { "button-icon delete-icon": true }, icon: "menus/delete", type: "tertiary", onClick: () => this.clearCombo(), tabindex: "-1", fit: true, disabled: this.disabled, part: this.parts.clearButton })) : null, h("gxg-button", { class: { "button-icon": true }, icon: "navigation/arrow-down", type: "secondary-icon-only", onClick: this.toggleListButtonClickHandler, fit: true, disabled: this.disabled, tabindex: "-1", part: this.parts.toggleButton }))), h("div", { class: {
                "items-container": true,
                "items-container--not-popover": !this.popOver,
                "items-container--show": this.listIsOpen && !this.popOver,
                "items-container--popover": this.popOver,
                "items-container--no-match": this.noMatch,
                "items-container--below": this.listPosition === "below",
                "items-container--above": this.listPosition === "above",
            }, style: { maxHeight: this.listMaxHeight }, ref: (el) => (this.itemsContainer = el) }, h("slot", null), this.noMatch && this.strict ? (h("div", { class: "no-ocurrences-found" }, "No occurrences found", h("span", null, "ctrl/cmd + backspace to erase"))) : null)), this.toolTip ? formTooltipLogic(this, false) : null)), !this.toolTip ? formMessageLogic(this) : null));
    }
    static get is() { return "gxg-combo-box"; }
    static get encapsulation() { return "shadow"; }
    static get delegatesFocus() { return true; }
    static get originalStyleUrls() {
        return {
            "$": ["combo-box.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["combo-box.css"]
        };
    }
    static get properties() {
        return {
            "popOver": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute applies the popover attribute to the list of items. This is useful if the combo-box is wrapped inside a \"@container\" responsive container, since at the time of writing, fixed positioned elements that are inside a \"@container\" container, are relative to the container, not the viewport."
                },
                "attribute": "pop-over",
                "reflect": false,
                "defaultValue": "false"
            },
            "toolTip": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute displays a tooltip message, instead of a block message below the control"
                },
                "attribute": "tool-tip",
                "reflect": false,
                "defaultValue": "false"
            },
            "fixedIcon": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "A fixed icon that will show on the combo, ignoring the combo-box-item's icons."
                },
                "attribute": "fixed-icon",
                "reflect": false
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute makes the input disabled"
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The combo label"
                },
                "attribute": "label",
                "reflect": false,
                "defaultValue": "undefined"
            },
            "labelPosition": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "LabelPosition",
                    "resolved": "\"above\" | \"below\" | \"end\" | \"start\"",
                    "references": {
                        "LabelPosition": {
                            "location": "import",
                            "path": "../../common/types",
                            "id": "src/common/types.ts::LabelPosition"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The input label"
                },
                "attribute": "label-position",
                "reflect": true,
                "defaultValue": "\"above\""
            },
            "minWidth": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The combo min-width"
                },
                "attribute": "min-width",
                "reflect": false,
                "defaultValue": "\"0\""
            },
            "maxWidth": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The combo max-width"
                },
                "attribute": "max-width",
                "reflect": false,
                "defaultValue": "\"100%\""
            },
            "listMaxHeight": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The combo list max height"
                },
                "attribute": "list-max-height",
                "reflect": false,
                "defaultValue": "\"244px\""
            },
            "placeholder": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The combo placeholder"
                },
                "attribute": "placeholder",
                "reflect": false,
                "defaultValue": "\"Search item\""
            },
            "disableFilter": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute disables the filter"
                },
                "attribute": "disable-filter",
                "reflect": false,
                "defaultValue": "false"
            },
            "disableClear": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute disables the clear button"
                },
                "attribute": "disable-clear",
                "reflect": false,
                "defaultValue": "false"
            },
            "strict": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If this attribute is present, \"value\" will only return something if a comboItem is selected, otherwise it will return undefined.\nif this attribute is not present, \"value\" will return the value of the actual comboItem, or whatever text the comboItem has."
                },
                "attribute": "strict",
                "reflect": false,
                "defaultValue": "false"
            },
            "value": {
                "type": "any",
                "mutable": false,
                "complexType": {
                    "original": "ComboBoxItemValue",
                    "resolved": "any",
                    "references": {
                        "ComboBoxItemValue": {
                            "location": "import",
                            "path": "../combo-box-item/combo-box-item",
                            "id": "src/components/combo-box-item/combo-box-item.tsx::ComboBoxItemValue"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The current combo box item value"
                },
                "attribute": "value",
                "reflect": false
            },
            "caseSensitive": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute with make the filter search for values with case sensitive distinction"
                },
                "attribute": "case-sensitive",
                "reflect": false,
                "defaultValue": "false"
            },
            "listPosition": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "ListPosition",
                    "resolved": "\"above\" | \"below\"",
                    "references": {
                        "ListPosition": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/combo-box/combo-box.tsx",
                            "id": "src/components/combo-box/combo-box.tsx::ListPosition"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The container 'items container' position"
                },
                "attribute": "list-position",
                "reflect": false,
                "defaultValue": "\"below\""
            },
            "centerLabel": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Centers the label"
                },
                "attribute": "center-label",
                "reflect": false,
                "defaultValue": "false"
            },
            "labelWidth": {
                "type": "any",
                "mutable": false,
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The label width"
                },
                "attribute": "label-width",
                "reflect": false
            },
            "required": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute makes the commbo required"
                },
                "attribute": "required",
                "reflect": true,
                "defaultValue": "false"
            },
            "validationStatus": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "ValidationStatus",
                    "resolved": "\"error\" | \"indeterminate\" | \"success\" | \"warning\"",
                    "references": {
                        "ValidationStatus": {
                            "location": "import",
                            "path": "../../common/types",
                            "id": "src/common/types.ts::ValidationStatus"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The validation status"
                },
                "attribute": "validation-status",
                "reflect": false,
                "defaultValue": "\"indeterminate\""
            },
            "validationMessage": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The message to display when validation fails (error)"
                },
                "attribute": "validation-message",
                "reflect": false
            },
            "cursorEnd": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If true, it will position the cursor at the end when the input is focused."
                },
                "attribute": "cursor-end",
                "reflect": false,
                "defaultValue": "false"
            },
            "informationMessage": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "An informative message to help the user filling the information"
                },
                "attribute": "information-message",
                "reflect": false
            }
        };
    }
    static get states() {
        return {
            "text": {},
            "inputTextValue": {},
            "listIsOpen": {},
            "inputTextIcon": {},
            "noMatch": {},
            "lastAllowedValue": {},
            "slottedContent": {},
            "selectionProgramatic": {},
            "lastSetValueByUser": {},
            "myObserver": {},
            "selectedItem": {},
            "removedItem": {}
        };
    }
    static get events() {
        return [{
                "method": "valueChanged",
                "name": "valueChanged",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "This event is triggered when the combo box value changes."
                },
                "complexType": {
                    "original": "ComboBoxItemValue",
                    "resolved": "any",
                    "references": {
                        "ComboBoxItemValue": {
                            "location": "import",
                            "path": "../combo-box-item/combo-box-item",
                            "id": "src/components/combo-box-item/combo-box-item.tsx::ComboBoxItemValue"
                        }
                    }
                }
            }, {
                "method": "opened",
                "name": "opened",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "This event is triggered when the combo dropdown is opened"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "closed",
                "name": "closed",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "This event is triggered when the combo dropdown has closed"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "toggled",
                "name": "toggled",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "This event is triggered when the combo dropdown has toggled (opened/closed)"
                },
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                }
            }];
    }
    static get methods() {
        return {
            "open": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "*******************************\nMETHODS\n*******************************",
                    "tags": []
                }
            },
            "close": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            },
            "getValueByIndex": {
                "complexType": {
                    "signature": "(index: number) => Promise<string>",
                    "parameters": [{
                            "name": "index",
                            "type": "number",
                            "docs": ""
                        }],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<string>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            },
            "setValueByIndex": {
                "complexType": {
                    "signature": "(index: number) => Promise<boolean>",
                    "parameters": [{
                            "name": "index",
                            "type": "number",
                            "docs": ""
                        }],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<boolean>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            },
            "selectInputText": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "value",
                "methodName": "onValueChanged"
            }, {
                "propName": "listIsOpen",
                "methodName": "listIsOpenHandler"
            }, {
                "propName": "selectedItem",
                "methodName": "selectedItemHandler"
            }, {
                "propName": "removedItem",
                "methodName": "removedItemHandler"
            }];
    }
    static get listeners() {
        return [{
                "name": "itemSelected",
                "method": "itemSelectedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }, {
                "name": "itemDidLoad",
                "method": "itemDidLoadHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }, {
                "name": "keyDownComboItem",
                "method": "keyDownComboItemHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=combo-box.js.map
